module.exports = __webpack_public_path__ + "static/media/logo.093f845a.png";